import dayjs from 'dayjs';
import { Booking } from '../hooks/useCart';
import { getCurrency } from './format';

export const addCartItemsEvent = (eventName: string, bookings: Booking[], extraData: any = {}) => {
  console.log(`Event triggered: ${eventName} with bookings:`, bookings);
  window.dataLayer?.push({
    event: eventName,
    ecommerce: {
      ...extraData,
      items: bookings.map(booking => ({
        item_id: booking.id,
        item_name: `${booking.service.serviceName}-${booking.serviceDuration.durationTime}-${dayjs(
          booking.date + booking.startTime,
          'YYYYMMDDHHmm'
        ).format('DD/MM/YYYY HH:mm')}`,
        item_category: booking.service.serviceName,
        price: booking.price,
        quantity: booking.quantity,
        ...(booking.addonsPurchases?.length && {
          addons: booking.addonsPurchases?.map(purchase => ({
            addon_id: purchase.addon.id,
            addon_name: purchase.addon.name,
            addon_price: purchase.addon.price,
            addon_quantity: purchase.quantity,
            paid_amount: purchase.paidAmount,
          })),
        }),
      })),
    },
  });
};

export function triggerPurchaseEvent(
  bookings: Booking[],
  cart: any,
  cartId: string,
  currency: string
) {
  if (!cartId || bookings.length === 0) return;

  const purchaseStorageKey = `ga4_purchase_${cartId}`;

  try {
    if (window.sessionStorage.getItem(purchaseStorageKey)) {
      return;
    }
    // Mark immediately to prevent duplicate events from repeated renders/fetches.
    window.sessionStorage.setItem(purchaseStorageKey, 'true');
  } catch (error) {
    // If storage is unavailable, continue and allow event sending.
    console.error('Failed to access sessionStorage for purchase event dedupe:', error);
  }

  setTimeout(
    () =>
      addCartItemsEvent('purchase', bookings, {
        transaction_id: cartId,
        currency: getCurrency(currency),
        value: cart?.newCartTotal,
        quantity: bookings.length,
      }),
    3000
  );
}
